import { PagesEnum } from "../../enums";

/**
 * Where sign-in sends the customer back to, from Login's `?returnTo=`. The
 * value is carried from Login through Verify (useAuth, VerifyPhone) and read
 * once the token is issued.
 *
 * - `location`: the address picker that asked for an account.
 * - `wallet`: the Wallet page's "Sign in to see your balance"
 *   (prepits/project#4263) -- the story brings the customer back to the
 *   Wallet page; the menu tab's link adds no returnTo and lands on Home.
 *
 * `offline-mode` is not here: the offline-mode screens run their own flow.
 */
const SIGN_IN_RETURN_PAGES: Record<string, PagesEnum> = {
  location: PagesEnum.Location,
  [PagesEnum.Wallet]: PagesEnum.Wallet,
};

export const getSignInReturnPage = (
  returnTo: string | string[] | undefined
): PagesEnum | null =>
  (typeof returnTo === "string" && SIGN_IN_RETURN_PAGES[returnTo]) || null;
